import { GemsApi_StoneCut } from '@/graphql/api'
import { computed, type ComputedRef, type Ref, toValue } from 'vue'
import { findOrder } from '@/domain/stone/search/findOrder'

const ordered: GemsApi_StoneCut[] = [
    GemsApi_StoneCut.Ideal,
    GemsApi_StoneCut.Excellent,
    GemsApi_StoneCut.VeryGood,
    GemsApi_StoneCut.Good,
] as const

function findCutOrder(code: GemsApi_StoneCut) {
    return findOrder(ordered, code)
}

export function useOrderedCut(
    shapes: Ref<GemsApi_StoneCut[]> | (() => GemsApi_StoneCut[])
): ComputedRef<GemsApi_StoneCut[]> {
    return computed(() => {
        return toValue(shapes).sort(
            (a: GemsApi_StoneCut, b: GemsApi_StoneCut) => {
                const orderA = findCutOrder(a)
                const orderB = findCutOrder(b)

                return orderA - orderB
            }
        )
    })
}
